module.exports = __webpack_public_path__ + "static/img/icon-06.05db2013.png";